import { render, staticRenderFns } from "./pesoParaLaEdadNinas0a2A.vue?vue&type=template&id=7bf22f0d&scoped=true&"
import script from "./pesoParaLaEdadNinas0a2A.vue?vue&type=script&lang=js&"
export * from "./pesoParaLaEdadNinas0a2A.vue?vue&type=script&lang=js&"
import style0 from "./pesoParaLaEdadNinas0a2A.vue?vue&type=style&index=0&id=7bf22f0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf22f0d",
  null
  
)

export default component.exports